export default __webpack_public_path__ + "static/media/1A_thumbnail.29c1c566.JPG";